import React from 'react'
import moment from "moment";
import { Box, Typography } from '@mui/material'

import styles from "./OrderHistory.module.css";
import { DELIVERY, PICKUP, formatPrice } from "../../../constants";

const OrderListCard = ({ data, onOrderItemClick }) => {
    return (
        <Box mb={3}>
            <Typography className={styles.orderDateTitleText}>
                {data.date == moment().format("DD MMM Y") ? "Today" : data.date}
            </Typography>
            <Box mt={1}>
                {data.list.map((orderItem, i) => {
                    return (
                        <Box
                            key={i}
                            className={styles.orderListView}
                            onClick={() => onOrderItemClick(orderItem)}
                            py={1.5}
                            px={2}
                        >
                            {/* Top row: Order ID + badges | Price */}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                        <Typography className={styles.orderIdText}>
                                            Order #{orderItem.orderRef ?? orderItem._id.toString().substr(-5)}
                                        </Typography>
                                        <Box
                                            className={styles.orderTypeText}
                                            style={{
                                                backgroundColor:
                                                    orderItem.orderType == DELIVERY || orderItem.orderType == PICKUP
                                                        ? "#960090"
                                                        : "#1D86FF",
                                                borderRadius: '5px',
                                                padding: '2px 8px',
                                            }}
                                        >
                                            {[DELIVERY, PICKUP].includes(orderItem.orderType)
                                                ? "Online Order"
                                                : orderItem.orderType === 4
                                                    ? "Table Order"
                                                    : "Dine in"}
                                        </Box>
                                        {(orderItem.transactionStatus) && (
                                            <Box
                                                px={1}
                                                py={0.3}
                                                sx={{
                                                    backgroundColor:
                                                        orderItem.transactionStatus === "PAID"
                                                            ? "#22c55e"
                                                            : orderItem.transactionStatus === "REFUNDED"
                                                                ? "#ef4444"
                                                                : orderItem.transactionStatus === "PARTIALLY_REFUNDED"
                                                                    ? "#f59e0b"
                                                                    : orderItem.transactionStatus === "PENDING"
                                                                        ? "#f59e0b"
                                                                        : "#6b7280",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: 10,
                                                        fontFamily: "InterMedium",
                                                        color: "#fff",
                                                        textTransform: "capitalize",
                                                    }}
                                                >
                                                    {orderItem.transactionStatus?.replace(/_/g, ' ')}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                        <Typography className={styles.orderDateText} sx={{ opacity: 0.7 }}>
                                            {orderItem?.date}
                                        </Typography>
                                        {orderItem.userDetails?.name ? (
                                            <Typography className={styles.orderNameText}>
                                                {orderItem.userDetails.name}
                                            </Typography>
                                        ) : null}
                                    </Box>
                                </Box>
                                <Box sx={{ textAlign: "right", flexShrink: 0, ml: 2 }}>
                                    <Typography className={styles.orderPriceValText}>
                                        {orderItem.price?.currency} {formatPrice(orderItem.price?.value, orderItem.price?.currency)}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Bottom row: financial details (only if discount or refund exists) */}
                            {(orderItem.discountAmount > 0 || (orderItem.onlinePayemtInfo?.[0]?.refunds || []).reduce((s, r) => s + (r.amount || 0), 0) > 0) && (
                                <Box sx={{ display: "flex", gap: 2, mt: 1, pt: 1, borderTop: "1px solid #E0E0E022", width: "100%" }}>
                                    {orderItem.discountAmount > 0 && (
                                        <Typography sx={{ fontSize: 11, fontFamily: "InterMedium", color: "#F57C00" }}>
                                            Discount: -{orderItem.price?.currency} {orderItem.discountAmount?.toFixed(2)}
                                        </Typography>
                                    )}
                                    {(() => {
                                        const refunds = orderItem.onlinePayemtInfo?.[0]?.refunds || [];
                                        const refundedAmt = refunds.reduce((sum, r) => sum + (r.amount || 0), 0);
                                        if (refundedAmt <= 0) return null;
                                        const remaining = Math.max(0, (orderItem.remainingToPay || 0) - refundedAmt);
                                        return (
                                            <>
                                                <Typography sx={{ fontSize: 11, fontFamily: "InterMedium", color: "#C62828" }}>
                                                    Refunded: -{orderItem.price?.currency} {refundedAmt.toFixed(2)}
                                                </Typography>
                                                <Typography sx={{ fontSize: 11, fontFamily: "InterSemiBold", color: "#148E20" }}>
                                                    Balance: {orderItem.price?.currency} {remaining.toFixed(2)}
                                                </Typography>
                                            </>
                                        );
                                    })()}
                                </Box>
                            )}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}

export default React.memo(OrderListCard);